import * as React from 'react';

import { CardMetadata } from '@coursera/cds-core';

import type { FormattedDegree } from 'bundles/unified-description-page-common/components/modules/credits/DegreeCard';
import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import { getXdpDegreeCardCopy } from 'bundles/unified-description-page-common/utils/degreeCardCopy';

/**
  This utility function formats the raw degree data for an XDP's DegreeCards.
  It takes in an array of raw degree data.
  It returns an array of formatted degree data.
  @param {DegreeFragment[]} rawDegrees - An array of raw degree objects. Each object should have properties: name, slug, headerImage, id, duration, and upsellPartners.
  @returns {FormattedDegree[]} - An array of formatted degree objects. Each object will have properties: name, slug, headerImage, id, cardFooter, and partner.
*/
export const formatPageDataDegrees = (rawDegrees: DegreeFragment[]): FormattedDegree[] => {
  const formattedDegrees = rawDegrees.map((rawDegree) => {
    const footerCopy = getXdpDegreeCardCopy(rawDegree.duration);

    return {
      name: rawDegree.name,
      slug: rawDegree.slug,
      thumbnailUrl: rawDegree.headerImage,
      id: rawDegree.id,
      cardFooter: <CardMetadata metadata={footerCopy} />,
      partner: { name: rawDegree.upsellPartners?.[0]?.name || '', logoUrl: rawDegree.upsellPartners?.[0]?.squareLogo },
    };
  });

  // @ts-expect-error URL: string
  return formattedDegrees;
};
